"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE = void 0;
/** Supported hash types */
var TYPE;
(function (TYPE) {
    TYPE["KECCAK256"] = "keccak256";
})(TYPE || (exports.TYPE = TYPE = {}));
//# sourceMappingURL=hash-types.js.map